import {
  computed,
  defineComponent,
  onMounted,
  reactive,
} from '@vue/composition-api';
import 'filepond/dist/filepond.min.css';
import 'filepond-plugin-get-file/dist/filepond-plugin-get-file.min.css';
import { Typography, FileUploader, List, ListItem, Dialog } from '../../parts';
import { useInputFile } from '@/shared/hooks/useInputFile';
import { useTitle } from '@/shared/hooks/useTitle';
import { useOfficialDocument } from '@/shared/hooks/useOfficialDocument';
import { useDialog } from '@/hooks/useDialog';
import { useStore } from '@/store';
import dayjs from 'dayjs';

export type ReactiveData = {
  listItems: ListItem[];
};

export default defineComponent({
  components: { List, Typography, FileUploader, Dialog },
  setup() {
    const { getters } = useStore();
    const { setTitle } = useTitle();
    const { files, handleChangeFile } = useInputFile();
    const { state: dialogState, openDialog, closeDialog } = useDialog();

    const {
      saveOfficialDocument,
      getOfficialDocument,
      downloadOfficialDocumentTemplate,
    } = useOfficialDocument({
      organization_type_id: 1,
    });

    const state = reactive<ReactiveData>({
      listItems: [],
    });

    const fetch = async () => {
      const officialDocument = await getOfficialDocument();

      const listItems = [
        {
          label: '登録周知文書',
          content: officialDocument.name,
          download: downloadOfficialDocumentTemplate,
        },
        {
          label: '更新日時',
          content: dayjs(officialDocument.updatedAt).format('YYYY/MM/DD HH:mm'),
        },
        {
          label: '更新者',
          content: officialDocument.updatedBy,
        },
      ];
      state.listItems = listItems;
    };

    onMounted(async () => {
      setTitle({
        title: '周知文書登録（県立高等学校）',
        icon: 'mdi-square-edit-outline',
      });
      fetch();
    });

    const uploadFile = async () => {
      const formData = new FormData();
      formData.append('organization_type_id', '1');
      formData.append('official_document', files.value[0].file);

      return saveOfficialDocument(formData).then(fetch);
    };

    return {
      state,
      files,
      handleChangeFile,
      uploadFile,
      disabled: computed(() => !files.value.length),
      dialogState,
      openDialog,
      closeDialog,
      accept: getters.validation.notification_file_mimetype,
    };
  },
});
